import { gatewayInstance } from "../axiosInstance";

export const addAuditRecord = async (data) => {
  try {
    await gatewayInstance.post(`/auditingservice/audit`, data);
  } catch (e) {
    console.error(e);
  }
};

export const addDirectionServiceAudit = async (data) => {
  try {
    await gatewayInstance.post(`/auditingservice/direction/audit`, data);
  } catch (e) {
    console.error(e);
  }
};
